<template>
  <div class="problemButton">
    <!--    <span>功能</span>-->
    <button v-if="showQuestionButton" @click="$emit('getProblem')">常见问题</button>
    <button @click="handleBackMsg">撤回消息</button>
  </div>
</template>
<script>
import MyVue from '@/MyVue'
import { mapState } from 'vuex'
export default {
  name: 'Index',
  computed: {
    ...mapState(['showQuestionButton'])
  },
  methods: {
    handleBackMsg() {
      MyVue.$emit('backMsg')
    }
  }
}
</script>
<style lang="stylus" scoped>
  .problemButton {
    height: 29px
    box-sizing border-box
    padding 5px 15px 2px 15px;
    span {
      color #333333
      font-size 12px
      margin-right 5px;
    }
    button {
      padding 0 9px
      height 22px
      line-height 22px;
      background-color: #fff;
      border-radius 14px
      border 1px solid #999999
      color #333333
      cursor pointer
      font-size: 12px;
    }
    button:hover {
      border-color #1967f3
      color #1967f3
    }
  }
</style>
